import EPYCExplorerLogo from "../../images/logos/EPYCExplorerLogo";
import AMDGoogleCloudLogo from "../../images/logos/AMDGoogleCloudLogo";

import "../../styles/components/sidebar/Logos.scss"

export default function Logos() {
  return (
    <div className="Logos">      
      <AMDGoogleCloudLogo />
      <EPYCExplorerLogo />
    </div>
  );
}
